export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7860.2e483ce5.jpg";